import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getBusinessPlanCurrency } from 'store/useBusinessToolStore/selectors';

import { getCurrencySymbol } from 'helpers/getCurrencySymbol';

export const useGetCurrencySymbol = () => {
  const currency = useBusinessToolStore(getBusinessPlanCurrency);
  const currencySymbol = getCurrencySymbol(currency) ?? '$';
  return currencySymbol;
};
